import ExpensesTransactionsReducer, {
  Actions as ExpensesTransactionsActions,
  ExpensesTransactionsState,
  initialState as initialExpensesTransactionsState,
} from 'src/app/ExpensesTransactions/redux/expensesTransactions.reducer'
import TransactionsAllTransactionsReducer, {
  Actions as TransactionsAllTransactionsActions,
  initialState as initialTransactionsAllTransactionsState,
  TransactionsAllTransactionsState,
} from 'src/app/TransactionsAllTransactions/redux/transactionsAllTransactions.reducer'

export type TransactionsState = {
  expensesTransactions: ExpensesTransactionsState
  transactionsAllTransactions: TransactionsAllTransactionsState
}

export const initialState: TransactionsState = {
  expensesTransactions: initialExpensesTransactionsState,
  transactionsAllTransactions: initialTransactionsAllTransactionsState,
}

export type Actions =
  | TransactionsAllTransactionsActions
  | ExpensesTransactionsActions

const TransactionsReducer = (
  state = initialState,
  action: Actions,
): TransactionsState => ({
  expensesTransactions: ExpensesTransactionsReducer(
    state.expensesTransactions,
    action as ExpensesTransactionsActions,
  ),
  transactionsAllTransactions: TransactionsAllTransactionsReducer(
    state.transactionsAllTransactions,
    action as TransactionsAllTransactionsActions,
  ),
})

export default TransactionsReducer
